'use strict';

var UserExclusionRulesTransformerFactory = function UserExclusionRulesTransformerFactory(DataTransformer, momentService) {
  var DEFAULT_EXCLUSION_RULES_BEGIN_DATE = '2000-01-01';
  var DEFAULT_EXCLUSION_RULES_END_DATE = '2100-12-31';
  function UserExclusionRulesTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'user-exclusion-rules-mode';
  }
  UserExclusionRulesTransformer.prototype = Object.create(DataTransformer.prototype);
  UserExclusionRulesTransformer.constructor = UserExclusionRulesTransformer;
  UserExclusionRulesTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  UserExclusionRulesTransformer.prototype.isCacheable = function () {
    return false;
  };
  UserExclusionRulesTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  UserExclusionRulesTransformer.prototype.transform = function (data) {
    var exclusionRules = data.domain.pricingExclusions;
    var result = [];
    for (var i = 0; i < exclusionRules.length; i++) {
      var exclusionRule = exclusionRules[i];
      var exclusion = {
        originCountry: transformFromAsterisk(exclusionRule.originCountry),
        destinationCountry: transformFromAsterisk(exclusionRule.destinationCountry),
        originAirport: transformFromAsterisk(exclusionRule.origin),
        destinationAirport: transformFromAsterisk(exclusionRule.destination),
        fareFamily: transformFromAsterisk(exclusionRule.fareFamily),
        cabin: transformFromAsterisk(exclusionRule.cabin),
        fareClass: transformFromAsterisk(exclusionRule.fareClass),
        dows: exclusionRule.dows,
        pos: transformFromAsterisk(exclusionRule.pos),
        flights: transformFromAsterisk(exclusionRule.flights),
        fromRunDate: momentService.of(transformBeginDateFromAsterisk(exclusionRule.startRunDate), momentService.FIELD.PRICING_EXCLUSION_RULES_DATE),
        toRunDate: momentService.of(transformEndDateFromAsterisk(exclusionRule.endRunDate), momentService.FIELD.PRICING_EXCLUSION_RULES_DATE),
        fromTravelDate: momentService.of(transformBeginDateFromAsterisk(exclusionRule.startTravelDate), momentService.FIELD.PRICING_EXCLUSION_RULES_DATE),
        toTravelDate: momentService.of(transformEndDateFromAsterisk(exclusionRule.endTravelDate), momentService.FIELD.PRICING_EXCLUSION_RULES_DATE),
        lastUpdatedDate: momentService.of(exclusionRule.lastUpdatedDate, momentService.FIELD.LAST_UPDATED_AT),
        lastUpdatedBy: exclusionRule.lastUpdatedBy,
        notes: exclusionRule.label
      };
      result.push(exclusion);
    }
    return result;
  };
  function transformFromAsterisk(field) {
    return field === '*' ? 'All' : field;
  }
  function transformBeginDateFromAsterisk(field) {
    return field === '*' ? DEFAULT_EXCLUSION_RULES_BEGIN_DATE : field;
  }
  function transformEndDateFromAsterisk(field) {
    return field === '*' ? DEFAULT_EXCLUSION_RULES_END_DATE : field;
  }
  return UserExclusionRulesTransformer;
};
UserExclusionRulesTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = UserExclusionRulesTransformerFactory;